<template>
    <client-page-full-page class="app--main">

        <full-page ref="fullpage" :options="options" id="fullpage">

            <div class="fullpage-section fullpage-section--main">
                <sub-visual-full bg="/images/sub/visual/sv1-1.jpg">
                    <div class="text-ani-wrap">
                        <div class="text-ani">
                            <h2 class="font-weight-thin">함께, 더멀리</h2>
                        </div>
                        <div class="text-ani">
                            <h2 class="font-weight-bold">모두를 위한 기회를 만듭니다.</h2>
                        </div>
                    </div>
                </sub-visual-full>
            </div>

            <section class="fullpage-section fullpage-section--about" style="background-image: url(/images/sub/about/introduction/s1-bg.jpg);">
                <div class="fullpage-inner pb-0">
                    <v-container>
                        <div>
                            <v-row>
                                <v-col cols="12" md="6" lg="5" class="d-md-flex align-center" data-aos="fade-right">
                                    <div class="tit-wrap mb-0 text-left">
                                        <h3 class="tit font-weight-bold color-point">
                                            About us
                                        </h3>
                                        <p class="tit-txt color-white">
                                            1995년 설립된 세일즈웍스는 국제적인 네트워크와 <br class="d-none d-xl-block">
                                            풍부한 경험을 바탕으로 전문적인 세일즈 & 구독 <br class="d-none d-xl-block">
                                            대행 서비스를 제공하는 글로벌 기업입니다. 아시아 <br class="d-none d-xl-block">
                                            8개국에 지사를 운영하고 있으며 한국 법인인 <br class="d-none d-xl-block">
                                            세일즈웍스 코리아는 전국 주요 도시에 지점을 <br class="d-none d-xl-block">
                                            운영하고 있습니다.
                                        </p>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6" offset-lg="1" data-aos="fade-left">
                                    <v-img src="/images/sub/about/introduction/map.png" max-width="582" class="mx-auto"></v-img>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </div>
            </section>

            <section class="fullpage-section fullpage-section--wwd" style="background-image: url(/images/sub/about/introduction/s1-bg.jpg);">
                <div class="fullpage-inner">
                    <v-container>
                        <div class="mb-n4 mb-md-0">
                            <v-row>
                                <v-col cols="12" md="6" data-aos="fade-right">
                                    <div class="tit-wrap mb-0 text-left">
                                        <h3 class="tit font-weight-bold color-point">
                                            What we do
                                        </h3>
                                        <p class="tit-txt color-white">
                                            올바른 가치관을 가진 영업 인재들과 함께 고객사의 상품, <br class="d-none d-xl-block">
                                            서비스의 홍보 및 판매를 대행합니다. 비용 대비 높은 성과와 <br class="d-none d-xl-block">
                                            안정성을 보장하는 서비스로 다양한 산업 분야의 고객사로부터 <br class="d-none d-xl-block">
                                            높은 신뢰를 받고 있습니다. 
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="6" data-aos="fade-left">
                                    <p class="tit-txt color-white">
                                        세일즈웍스는 함께하는 모두의 기회 창출을 중요시합니다. <br class="d-none d-xl-block">
                                        고객사에게는 사업 성장의 기회를, 구성원에게는 커리어를 <br class="d-none d-xl-block">
                                        확장할 수 있는 성장과 발전의 기회를 제공합니다. 기존 사업의 <br class="d-none d-xl-block">
                                        고도화, 산업 분야 및 활동 국가 확대, 경쟁력 있는 전문 인재 <br class="d-none d-xl-block">
                                        양성을 통해 세일즈웍스는 글로벌 세일즈 플랫폼으로 도약하고 <br class="d-none d-xl-block">
                                        있습니다.  
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </div>
            </section>

            <section class="fullpage-section fullpage-section--support" style="background-color: #0c0c0c;">
                <div class="fullpage-section--support__bg" data-aos="fade"></div>
                <div class="fullpage-inner">
                    <v-container>
                        <div class="bg-image pa-20 pa-md-30 py-lg-74 px-lg-70 mx-auto mw-100" style="background-image: url(/images/sub/about/introduction/s2-txt-bg.jpg); width: 600px;" data-aos="zoom-in-up" data-aos-delay="300">
                            <div class="tit-wrap color-white mb-0">
                                <h3 class="tit font-weight-bold">
                                    서포트웍스
                                </h3>
                                <p class="tit-txt mt-18 mt-lg-38">
                                    구독서비스, 커머셜 상품, 스타트업 서비스 등 <br class="d-none d-md-block">
                                    다양한 분야와 함께 일해온 세일즈웍스는 <br class="d-none d-md-block">
                                    펀드레이징을 전문적으로 전담하는 브랜드 <br class="d-none d-md-block">
                                    서포트웍스를 운영합니다. NGO의 가치와 <br class="d-none d-md-block">
                                    의미를 전달하고 후원자를 연결하는 서포트웍스는 <br class="d-none d-md-block">
                                    전문 펀드레이저를 양성하고 파견하며 NGO를 <br class="d-none d-md-block">
                                    위한 토탈 솔루션을 제공합니다.  
                                </p>
                                <v-btn color="secondary" href="https://www.supportworks.kr/" target="_blank" class="w-lg-220px mt-22 mt-lg-40"> 
                                    서포트웍스 홈페이지
                                </v-btn>
                            </div>
                        </div>
                    </v-container>
                </div>
            </section>
        
            <div class="fullpage-section fullpage-section--etc">
                <section class="section bg-grey">
                    <v-container>
                        <div class="tit-wrap">
                            <h3 class="tit font-weight-bold">
                                수상내역
                            </h3>
                            <p class="tit-txt">
                                세일즈웍스 코리아는 국내외 다양한 부문 수상으로 성과를 인정받으며 <br class="d-none d-md-block">
                                꾸준히 성장해왔습니다.
                            </p>
                        </div>
                        <v-row class="my-n10 my-lg-n30">
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img1.jpg"
                                year="2020"
                                tit="고객감동 우수 브랜드 대상"
                                sc="중앙일보">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img2.jpg"
                                year="2019"
                                tit="고객감동 우수 브랜드 대상"
                                sc="중앙일보">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img3.jpg"
                                year="2019"
                                tit="고객만족 경영 대상"
                                sc="동아일보">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img4.jpg"
                                year="2018"
                                tit="고객감동 우수 브랜드 대상"
                                sc="중앙일보">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img5.jpg"
                                year="2018"
                                tit="Stevie Awards 은상"
                                sc="Asia-Pacific">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img6.jpg"
                                year="2018"
                                tit="Business Awards 은상"
                                sc="International">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img7.jpg"
                                year="2017"
                                tit="Stevie Awards 은상"
                                sc="Asia-Pacific">
                                </award-item>
                            </v-col>
                            <v-col cols="6" md="3" class="py-10 py-lg-30">
                                <award-item
                                src="/images/sub/about/introduction/s4-img8.jpg"
                                year="2016"
                                tit="Stevie Awards 은상"
                                sc="Asia-Pacific">
                                </award-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </section>

                <section class="section">
                    <v-container>
                        <div class="tit-wrap text-left">
                            <v-row align="end">
                                <v-col cols="12" sm="auto">
                                    <h2 class="tit">
                                        세일즈웍스의 가치관과 <br class="d-none d-sm-block">
                                        방향성을 상징합니다
                                    </h2>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="auto" sm="auto" class="d-flex">
                                    <v-btn icon tile color="white" class="slide-btn-prev"><i class="icon icon-left-arrow2 mr-4 mr-lg-8"></i></v-btn>
                                    <v-btn icon tile color="white" class="slide-btn-next"><i class="icon icon-right-arrow2"></i></v-btn>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="pt-30 pt-lg-54 border-top border-2 border-lg-4 border-color-point w-100">
                            <div class="ci-slide">
                                <div class="swiper-container">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <v-row>
                                                <v-col cols="12" md="2" class="mb-10 mb-md-0">
                                                    <h5 class="bar-text">
                                                        CI
                                                    </h5>
                                                </v-col>
                                                <v-col cols="12" md="10">
                                                    <p class="page-text--sm color-grey-7 mb-30 mb-lg-54">
                                                        세일즈웍스의 로고는 기업의 시각적 정체성 그 이상입니다.  두 부분으로 구성된 심볼은 세일즈웍스의 가치관과 방향성을 나타냅니다.
                                                    </p>
                                                    <div class="mb-30 mb-lg-32">
                                                        <img src="/images/sub/about/introduction/ci1.jpg" alt="" class="w-100 border border-color-light d-none d-md-block">
                                                        <img src="/images/sub/about/introduction/ci1-mo.jpg" alt="" class="w-100 border border-color-light d-block d-md-none">
                                                    </div>
                                                    <v-row class="ma-sm-n4 ma-lg-n14 text-center">
                                                        <v-col cols="12" sm="4" class="pa-sm-4 pa-lg-14 mb-20 mb-sm-0">
                                                            <img src="/images/sub/about/introduction/ci1-3.jpg" alt="" class="w-100 border border-color-light d-block mb-8 mb-lg-14">
                                                            <p class="page-text--sm">
                                                                번개를 상징하는 ‘S’ 모양은 <br class="d-none d-lg-block">
                                                                고객 만족을 위한 <strong class="font-weight-bold">세일즈웍스의 <br class="d-none d-lg-block">
                                                                강한 에너지를 나타냅니다.</strong> 
                                                            </p>
                                                        </v-col>
                                                        <v-col cols="12" sm="4" class="pa-sm-4 pa-lg-14 mb-20 mb-sm-0">
                                                            <img src="/images/sub/about/introduction/ci1-2.jpg" alt="" class="w-100 border border-color-light d-block mb-8 mb-lg-14">
                                                            <p class="page-text--sm">
                                                                상향 화살표는 무한한 <br class="d-none d-lg-block">
                                                                발전을 향해가는 <strong class="font-weight-bold">세일즈웍스의 <br class="d-none d-lg-block">
                                                                의지를 나타냅니다.</strong> 
                                                            </p>
                                                        </v-col>
                                                        <v-col cols="12" sm="4" class="pa-sm-4 pa-lg-14">
                                                            <img src="/images/sub/about/introduction/ci1-4.jpg" alt="" class="w-100 border border-color-light d-block mb-8 mb-lg-14">
                                                            <p class="page-text--sm">
                                                                두 심볼이 합쳐진 ‘W’ 모양은 <br class="d-none d-lg-block">
                                                                <strong class="font-weight-bold">세일즈웍스의 핵심인 <br class="d-none d-lg-block">
                                                                WORKS를 상징합니다.</strong> 
                                                            </p>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="mb-50 mb-lg-100">
                                                <v-row>
                                                    <v-col cols="12" md="2" class="mb-10 mb-md-0">
                                                        <h5 class="bar-text">
                                                            Color
                                                        </h5>
                                                    </v-col>
                                                    <v-col cols="12" md="10">
                                                        <v-row>
                                                            <v-col cols="12" sm="4" class="mb-20 mb-sm-0">
                                                                <ci-color
                                                                type="dark"
                                                                tit="THRILLING RED"
                                                                pantone="P48-8 C"
                                                                rgb="235 / 33 / 43"
                                                                cmyk="1 / 99 / 94 / 0"
                                                                hex="#eb212b">
                                                                </ci-color>
                                                            </v-col>
                                                            <v-col cols="12" sm="4" class="mb-20 mb-sm-0">
                                                                <ci-color
                                                                type="dark"
                                                                tit="STEEL GREY"
                                                                pantone="412 C"
                                                                rgb="51 / 51 / 51"
                                                                cmyk="69 / 63 / 62 / 58"
                                                                hex="#333333">
                                                                </ci-color>
                                                            </v-col>
                                                            <v-col cols="12" sm="4">
                                                                <ci-color
                                                                tit="PURE WHITE"
                                                                pantone="P48-8 C"
                                                                rgb="255 / 255 / 255"
                                                                cmyk="0 / 0 / 0 / 0"
                                                                hex="#fffff">
                                                                </ci-color>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                            <div>
                                                <v-row>
                                                    <v-col cols="12" md="2" class="mb-10 mb-md-0">
                                                        <h5 class="bar-text">
                                                            Clear Space
                                                        </h5>
                                                    </v-col>
                                                    <v-col cols="12" md="10">
                                                        <p class="page-text--sm color-grey-7 mb-30 mb-lg-54">
                                                            로고 주변을 X & Y로 보며, X는 “W”가 상향하는 높이를 뜻합니다. 이 여백에는 다른 글자나 그래픽 요소가 들어가서는 안 됩니다.
                                                        </p>
                                                        <img src="/images/sub/about/introduction/ci2.jpg" alt="" class="w-100">
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-container>
                </section>

                <main-footer></main-footer>

            </div>

        </full-page>

        <u-scroll-top-full-page></u-scroll-top-full-page>

    </client-page-full-page>
</template>

<script>
import Swiper from "swiper/bundle";
import ClientPageFullPage from "@/pages/client/templates/ClientPage-FullPage.vue";
import UScrollTopFullPage from "@/components/dumb/u-scroll-top-full-page.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
import AwardItem from "@/components/client/sub/sub-award-item.vue";
import CiColor from "@/components/client/sub/sub-ci-color.vue";
// import ArrowBtn from "@/components/client/sub/arrow-btn.vue";
export default {
    components: {
        ClientPageFullPage,
        UScrollTopFullPage,
        MainFooter,
        SubVisualFull,
        AwardItem,
        CiColor,
        // ArrowBtn,
    },
    data() {
        return {
            options: {
                animateAnchor: false,
                anchors: ['Main', 'About', 'Wwd', 'Support', 'Etc'],
                sectionSelector: '.fullpage-section',
                scrollOverflow: true,
                fitToSection: true,
                scrollingSpeed: 600,
                responsiveWidth: 1200,
                responsiveHeight: 750,
                easingcss3: 'ease-in-out',
                licenseKey: 'BE202675-E3234C07-967F61A1-57A110B1',
                onLeave: this.onLeave,
                onSlideLeave: this.onSlideLeave,
                afterLoad: this.afterLoad,
                afterSlideLoad:this.afterSlideLoad,
            },
        }
    },
    mounted() {
        this.init();
    },    
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Visual = new Swiper(".ci-slide .swiper-container", {
                    allowTouchMove: true,
                    centeredSlides: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    speed: 500,
                    loop: true,
                    navigation: {
                        prevEl: '.slide-btn-prev',
                        nextEl: '.slide-btn-next',
                    },
                });
            });
        },
        // fullpage
        onLeave: function(){
            var fpActive = document.querySelector('.fp-section.active');
            var fpAos = fpActive.querySelectorAll('.aos-init');
            fpAos.forEach((item) => {
                item.classList.remove('aos-animate');
            });
        },
        onSlideLeave: function(){
            var fpActive = document.querySelector('.fp-section.active');
            var fpAos = fpActive.querySelectorAll('.aos-init');
            fpAos.forEach((item) => {
                item.classList.remove('aos-animate');
            });
        },
        afterLoad: function(origin, destination, direction){
            var fpActive = document.querySelector('.fp-section.active');
            var fpAos = fpActive.querySelectorAll('.aos-init');
            fpAos.forEach((item) => {
                item.classList.add('aos-animate');
            });
        },
        afterSlideLoad: function(){
            var fpActive = document.querySelector('.fp-section.active');
            var fpAos = fpActive.querySelectorAll('.aos-init');
            fpAos.forEach((item) => {
                item.classList.add('aos-animate');
            });
        },
    },};
</script>

<style scoped>
.fullpage-section--support__bg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(/images/sub/about/introduction/s2-bg.jpg);
}
</style>

